module.exports = "/_next/static/images/fallback-image-3-2-e6c8fc111fdc151021e7b2939389a13e.png";